import React from "react";

const Topbar = () => {
  return (
    <header className="h-16 bg-white shadow-sm flex items-center justify-between px-6">
      <h1 className="text-lg font-semibold text-[#95785A]">
        Dashboard
      </h1>

      <div className="flex items-center gap-4">
        <span className="text-sm text-gray-600">
          SuperAdmin
        </span>

        <div className="h-9 w-9 rounded-full bg-[#95785A] text-white flex items-center justify-center font-semibold">
          A
        </div>
      </div>
    </header>
  );
};

export default Topbar;
